<ui-modal
  class="alerts-modal"
  [isOpened]="showModal"
  modalTitle="Parameters For Alert"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="parameter">
    <div class="parameter__tables-container">
      <div class="parameter__table-info-group-container">
        <div class="parameter__table-info">
          <form [formGroup]="parametersFormGroup">
            <div #divToScroll class="table-container">
              <table ui-table *ngIf="parameters.length">
                <thead>
                  <tr>
                    <th
                      [ngClass]="parameter.shortName"
                      *ngFor="let parameter of parameters"
                    >
                      {{ parameter.longName }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr tabindex="0">
                    <ng-container *ngFor="let parameter of parameters">
                      <ng-container [ngSwitch]="parameter.type">
                        <ng-container *ngSwitchCase="'dropdown'">
                          <td [ngClass]="parameter.shortName">
                            <ng-select
                              [items]="parameter.options"
                              [searchable]="false"
                              [id]="parameter.shortName"
                              class="input-cell"
                              [formControlName]="parameter.shortName"
                              appendTo="body"
                              [clearable]="false"
                            >
                            </ng-select>
                          </td>
                        </ng-container>

                        <ng-container *ngSwitchCase="'number'">
                          <td [ngClass]="parameter.shortName">
                            <input
                              type="number"
                              [id]="parameter.shortName"
                              [ngClass]="['input-cell']"
                              [formControlName]="parameter.shortName"
                            />
                          </td>
                        </ng-container>

                        <ng-container *ngSwitchCase="'date'">
                          <td
                            id="date"
                            class="hide-clr-error"
                            [ngClass]="parameter.shortName"
                          >
                            <clr-date-container>
                              <input
                                type="date"
                                clrDate
                                [id]="parameter.shortName"
                                [formControlName]="parameter.shortName"
                              />
                            </clr-date-container>
                          </td>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
              <div
                class="table-container__no-parameters"
                *ngIf="!parameters.length"
              >
                No parameters are required for this Alert
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="fixingOutcomeSelected">
    <div class="parameter">
      <div class="parameter__tables-container">
        <div class="parameter__table-info-group-container">
          <div class="parameter__table-dates">
            <form [formGroup]="datesForm">
              <div #divToScroll class="table-container">
                <table ui-table class="table-container__parameters">
                  <thead>
                    <tr>
                      <th>Dates</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container formArrayName="datesArray">
                      <ng-container
                        *ngFor="let date of datesArray.controls; let i = index"
                      >
                        <tr
                          tabindex="0"
                          (click)="selectedDateIndex = i"
                          [ngClass]="{
                            'selected-row': selectedDateIndex === i
                          }"
                        >
                          <ng-container formGroupName="{{ i }}">
                            <td id="date" class="hide-clr-error">
                              <input
                                type="date"
                                clrDate
                                [ngClass]="['input-cell']"
                                [formControlName]="'date'"
                              />
                              <!-- {{date}} -->
                            </td>
                          </ng-container>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
                <div
                  class="table-container__no-parameters"
                  *ngIf="!parameters.length"
                >
                  No parameters are required for this Alert
                </div>
              </div>
            </form>
            <div class="bottom-table-add">
              <div>
                <span class="add-text-container">
                  <label class="Page-1">+</label
                  ><label class="add-text" (click)="addNewDate()"
                    >Add Date</label
                  ></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="parameter__footer">
      <button
        class="ui-button ui-button__header ui-button--danger ui-button--delete"
        [disabled]="selectedDateIndex === null"
        (click)="deleteDate()"
      >
        Delete
      </button>
    </div>
  </ng-container>
</ui-modal>
